import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject, of, tap } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { NetworkHelper } from '../helpers/network.helper';
import { environment } from '../environments/environment';
import { StorageService } from './storage.service';
import { User } from '../interfaces/user.interface';
import { CommonAccessTokenService } from './common-access-token.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  readonly apiUrl = `${environment.poolApi}/user`;

  private isAuthenticatedSubject = new ReplaySubject<boolean>(1);
  private userDataSubject = new BehaviorSubject<User | null>(null);
  private needTfaSubject = new BehaviorSubject<boolean>(false);

  readonly isAuthenticated$ = this.isAuthenticatedSubject.asObservable();
  readonly userData$ = this.userDataSubject.asObservable();
  readonly needTfa$ = this.needTfaSubject.asObservable();

  constructor(private networkHelper: NetworkHelper, private storageService: StorageService, private commonAccessTokenService: CommonAccessTokenService) {}
  getUser(): Observable<User | boolean> {
    const token = this.storageService.getToken() || '';

    if (!token || this.commonAccessTokenService.isAccessTokenPage()) {
      this.setAuthenticated(false);
      return of(false);
    } else {
      return this.networkHelper.get<User>(this.apiUrl).pipe(
        tap((response) => {
          this.setAuthenticated(true);
          this.setUserData(response);
        }),
        catchError(() => {
          this.setAuthenticated(false);
          return of(false);
        }),
        shareReplay(1)
      );
    }
  }

  setAuthenticated(status: boolean) {
    this.isAuthenticatedSubject.next(status);
  }

  setNeedTfa(status: boolean) {
    this.needTfaSubject.next(status);
  }

  setUserData(data: User) {
    this.userDataSubject.next(data);
  }
}
